<template>
    <div class="wf-product-display-controls">

        <div v-if="showSizeControl" class="wf-product-display-control wf-product-display-control-filter">
            <button class="wf-side-collapse-button wf-side-collapse-button-open btn shadow" type="button"
                data-wf-collapse-target="#filters-side-collapse">
                <span class="pr-3">{{ $resourceString["product.search.display.filter"] }}</span>
                <span class="png-icon png-icon-icons-glyph--k-sort-filter m-0" />
            </button>
        </div>
        <div class="wf-product-display-control wf-product-display-control-tile-size show-on-desktop">
            <select class="custom-select" name="product-display-tile-size" @change="setTileSize">
                <option disabled value="">
                    {{ $resourceString["product.search.display.tile.size"] }}
                </option>
                <option value="small" :selected="tileSize == 'small'">
                    {{ $resourceString["product.search.display.tile.size.small"] }}
                </option>
                <option value="large" :selected="tileSize == 'large'">
                    {{ $resourceString["product.search.display.tile.size.large"] }}
                </option>
            </select>
        </div>
        <div v-if="showSortControl" class="wf-product-display-control wf-product-display-control-sort-by">
            <select class="custom-select" name="product-display-sort-by" @change="setSortOrder">
                <option value="SellingStyleName desc" :selected="isAscendingOrder === 'desc'">
                    {{ $resourceString["product.search.display.sort.by.za"] }}
                </option>
                <option value="SellingStyleName asc" :selected="isAscendingOrder === 'asc'">
                    {{ $resourceString["product.search.display.sort.by.alphabet"] }}
                </option>
            </select>
        </div>
    </div>
</template>
  
<script>
import { Icon } from '@iconify/vue2';
import { mapGetters, mapActions } from 'vuex'

export default {
    props: {
        showSizeControl: {
            type: Boolean,
            default: true
        },
        showSortControl: {
            type: Boolean,
            default: true
        },
    },
    components: {
        Icon,
    },
    data() {
        return {
            isSelected(option) {
                return this.selectedFilters['Collection']?.includes(option);
            },
        }
    },
    computed: {
        ...mapGetters({
            filters: 'filters/filters',
            selectedFilters: 'filters/selectedFilters',
            items: 'productDisplay/items',
            viewMode: 'filters/viewMode',
            tileSize: 'filters/tileSize',
            sortOrder: 'filters/sortOrder',
            isAscendingOrder: 'filters/isAscendingOrder',
        }),
        collectionFilter() {
            return this.filters.find(element => element.azureFilterName === 'Collection');
        },
    },
    methods: {
        ...mapActions({
            onFilterClick: 'filters/onFilterClick',
        }),
        setViewMode: function (e) {
            if (e.target.checked) {
                this.$store.dispatch('filters/setViewMode', e.target.value);
            }
        },
        setTileSize: function (e) {
            this.$store.dispatch('filters/setTileSize', e.target.value);
        },
        setSortOrder: function (e) {
            this.$store.dispatch('filters/setSortOrder', e.target.value);
        },
    },
};
</script>
<style>
@media (max-width: 768px) {
  .show-on-desktop {
    display: none;
  }
}
</style>